export default __webpack_public_path__ + "static/media/applogo.c9dd40d0.png";